

















import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class AppButtonAddTreatment extends Vue {
  cancel = false;
  getRouteAddCustomer() {
    return this.$router.push({ name: "add-treatment" });
  }
}
